const graphQlPath = import.meta.env.api/graphql
const invoicePreviewPath = import.meta.env.api/invoice
const baseUrl = import.meta.env.BASE_URL

export { baseUrl, graphQlPath, invoicePreviewPath }
